<template>
  <div class="title">
    <p>检测系统</p>
  </div>
</template>

<script>
export default {

}
</script>

<style scoped>
.title p {
  height: 0.8rem;
  background: #228ef7;
  text-align: center;
  line-height: 0.8rem;
  color: #fff;
}
</style>